





































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import Gallery from '@/modules/cms/modules/gallery/model/Gallery'
import GalleryList from '@/modules/cms/modules/gallery/components/GalleryList.vue'
import {State} from 'vuex-class'
import {Prop, Watch} from 'vue-property-decorator'

/**
 * Selector de galería
 */
@Component({
    components: {GalleryList},
})
export default class GallerySelect extends Vue {
    @Prop({type: Gallery, default: () => (new Gallery())})
    public value: Gallery

    @Watch('value', {immediate: true})
    public onValueChange (val: Gallery) {
        // Omitir si no tiene id, debe estar registrada en el servidor
        if (val.isNew) {
            return
        }

        this.$store.commit('cms/gallery/SET_CURRENT_GALLERY', val)
    }

    /**
     * Galería cargada en el estado de la aplicación
     */
    @State(state => state.cms.gallery.currentGallery)
    public gallery: Gallery

    public gallerySelect = false
    public loadingGallery = false

    public async onSelect (gallery: Gallery) {
        this.loadingGallery = true
        this.gallerySelect = false
        await this.$store.dispatch('cms/gallery/loadGallery', gallery.id)

        // Se emite la galería completa
        this.$emit('input', _.cloneDeep(this.gallery))

        this.loadingGallery = false
    }

    public get placeholder () {
        return (this.loadingGallery || this.gallery.isNew) && !this.gallerySelect
    }
}
